import { Toolbar, Typography, Button, Box, Container } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/branding/logo_light.png";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";

const DesktopNav = () => {
  const location = useLocation();

  // Check if path matches current location
  const isActive = (path) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  // Navigation items
  const navItems = [
    { label: "Home", path: "/" },
    { label: "Services", path: "/services" },
    { label: "Rates", path: "/rates" },
    { label: "Insurance", path: "/insurance" },
    { label: "Blog", path: "/blog" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#ffffff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        borderBottom: "1px solid rgba(228, 181, 162, 0.1)",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          ml: { md: "4%", lg: "7%" },
          mr: { md: "4%", lg: "7%" },
          px: 0,
          width: "auto",
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "80px",
            padding: 0,
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexShrink: 0,
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-2px)",
              },
            }}
          >
            <Link to="/" style={{ display: "flex", alignItems: "center" }}>
              <img
                src={logo}
                alt="Dr. Anne Rothenberg Logo"
                style={{ height: "40px", width: "auto" }}
              />
            </Link>
          </Box>

          {/* Navigation Links */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { md: 0.5, lg: 2 },
            }}
          >
            {navItems.map((item) => (
              <Box
                key={item.label}
                sx={{
                  position: "relative",
                  mr: { md: 1, lg: 2 },
                }}
              >
                <Typography
                  component={Link}
                  to={item.path}
                  sx={{
                    color: isActive(item.path) ? "text.primary" : "#666",
                    fontWeight: isActive(item.path) ? 600 : 500,
                    fontSize: { md: "0.9rem", lg: "1rem" },
                    textDecoration: "none",
                    padding: "8px 2px",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      color: "text.primary",
                    },
                  }}
                >
                  {item.label}
                </Typography>

                {/* Active indicator underline */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: isActive(item.path) ? "100%" : "0%",
                    height: "2px",
                    backgroundColor: "secondary.main",
                    transition: "width 0.3s ease",
                    opacity: isActive(item.path) ? 1 : 0,
                  }}
                />

                {/* Hover indicator underline */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "0%",
                    height: "2px",
                    backgroundColor: "peach.main",
                    transition: "width 0.3s ease",
                    opacity: 0,
                    "&:hover": {
                      width: "100%",
                      opacity: 1,
                    },
                  }}
                />
              </Box>
            ))}

            {/* Consultation Button */}
            <Button
              component={Link}
              to="/request-consultation"
              variant="contained"
              startIcon={<ForumOutlinedIcon />}
              sx={{
                backgroundColor: "secondary.main",
                color: "text.primary",
                fontSize: { md: "0.8rem", lg: "0.9rem" },
                fontWeight: 600,
                padding: { md: "8px 12px", lg: "10px 18px" },
                borderRadius: "8px",
                textTransform: "none",
                whiteSpace: "nowrap",
                flexShrink: 0,
                boxShadow: "none",
                transition: "all 0.3s ease",
                ml: { md: 1, lg: 2 },
                "&:hover": {
                  backgroundColor: "peach.main",
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 12px rgba(228, 181, 162, 0.2)",
                },
              }}
            >
              Request Consultation
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </Box>
  );
};

export default DesktopNav;
